import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIcloudComponent } from './simple-icons-icloud.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIcloudComponent ],
    exports:      [ SimpleIconsIcloudComponent ],
    bootstrap:    []
})
export class SimpleIconsIcloudModule {}
